import { LoadingOutlined } from "@ant-design/icons";
import { ConfigProvider, Spin } from "antd";
import type { SpinProps } from "antd";
import { VLLoader_SPIN_THEMES, type VLLoaderThemeType } from "./themes";
import styles from "./style.module.scss";

export { VLLoader_SPIN_THEMES } from "./themes";
export type { VLLoaderThemeType } from "./themes";

export type VLLoaderProps = SpinProps & {
  themeType?: VLLoaderThemeType;
};

export function VLLoader({
  size = "large",
  themeType = "default",
  ...props
}: VLLoaderProps) {
  return (
    <ConfigProvider theme={VLLoader_SPIN_THEMES[themeType]}>
      <Spin
        {...props}
        size={size}
        indicator={<LoadingOutlined spin />}
        className={styles.vlLoader}
      />
    </ConfigProvider>
  );
}
